import { render, h } from 'preact'
import { useState, useLayoutEffect as useEffect } from 'preact/hooks'
import { setTitle } from '../lib/helper';

import "./home.cct.scss"
import TabBar from "../components/TabBar";
import Icon from "../components/Icon";
import Site from "../components/AutoForm/Site";
import router from '../lib/router';

const HomeCct = (props)=>{
    const [ postData,setPost ] = useState({});
    var {
        type
    } = props;

    useEffect(()=>{
        setTitle("首页");
    },[])

    return (
        <div className="homeCCT">
            <div className="bannerBox">
                <wx-swiper
                    behavior="swiper" 
                    indicator-dots={false}
                    autoplay={true}
                    // current={current}
                    style={{height:'50vw',width:"100vw"}}
                    >
                    {[
                        'https://assets.cxt.ant-code.com/images/banner_2.png',
                        'https://assets.cxt.ant-code.com/images/banner3.jpg'
                    ].map((fileUrl,index)=>{
                        return (
                            <div 
                            key={index} 
                            style={{
                                backgroundPosition:'center',
                                backgroundSize:'100%',
                                backgroundRepeat:'no-repeat',
                                backgroundImage:`url(${fileUrl})`,
                                width:"100vw",
                                height:"50vw"
                            }} 
                            // onClick={goAlbum}
                            // onClick={()=>{hanlderShowPhoto(fileUrl)}}
                            />
                        )
                    })}
                </wx-swiper>
            </div>

            <div style={{height:"0.5rem"}}/>

            <div className="navBox">
                {/* <div className="navBoxHeader">
                    <Icon icon="ios-bus" />
                    <div className="boxTitle">公交出行</div>
                </div> */}
                <div className="navBoxBody">
                    <div className="navList">
                        <div className="navItem" onClick={()=>{
                            router.go("home");
                            }}>
                            <div className="navIcon">
                                <img src="https://assets.cxt.ant-code.com/images/icon_bus_serach.svg" />
                            </div>
                            <div className="navLabel">查询公交</div>
                        </div>
                        <div className="navItem" onClick={()=>{
                                router.go("linesearch");
                            }}>
                            <div className="navIcon">
                                <img src="https://assets.cxt.ant-code.com/images/icon_site.svg" />
                            </div>
                            <div className="navLabel">线路查询</div>
                        </div>
                        <div className="navItem" onClick={()=>{
                                router.go("page?id=bus");
                            }}>
                            <div className="navIcon">
                                <img src="https://assets.cxt.ant-code.com/images/bus_two.svg" />
                            </div>
                            <div className="navLabel">呼叫班车</div>
                        </div>
                        <div className="navItem" onClick={()=>{
                                router.go("page?id=baocar");
                            }}>
                            <div className="navIcon">
                                <img src="https://assets.cxt.ant-code.com/images/icon_car.svg" />
                            </div>
                            <div className="navLabel">包车</div>
                        </div>
                        <div className="navItem" onClick={()=>{
                                // router.go("page?id=dingbus");
                                wx.navigateToMiniProgram({
                                    appId: 'wx6885acbedba59c14',
                                    success(res) {
                                        // 打开成功
                                    }
                                })
                            }}>
                            <div className="navIcon">
                                <img src="https://assets.cxt.ant-code.com/images/icon_bus_ding.svg" />
                            </div>
                            <div className="navLabel">定制客运</div>
                        </div>
                        <div className="navItem" onClick={()=>{
                                router.go("page?id=taxi");
                            }}>
                            <div className="navIcon">
                                <img src="https://assets.cxt.ant-code.com/images/icon_taxi.svg" />
                            </div>
                            <div className="navLabel">商务用车</div>
                        </div>
                        <div className="navItem" onClick={()=>{
                               router.go("page?id=times");
                            }}>
                            <div className="navIcon">
                                <img src="https://assets.cxt.ant-code.com/images/icon_times.svg" />
                            </div>
                            <div className="navLabel">客运时刻表</div>
                        </div>
                        <div className="navItem" onClick={()=>{
                               router.go("page?id=book");
                            }}>
                            <div className="navIcon">
                                <img src="https://assets.cxt.ant-code.com/images/icon_books.svg" />
                            </div>
                            <div className="navLabel">长途订票</div>
                        </div>
                        {/* <div className="navItem" onClick={()=>{
                               router.go("stores");
                            }}>
                            <div className="navIcon">
                                <img src="https://assets.cxt.ant-code.com/images/icon_location_store.svg" />
                            </div>
                            <div className="navLabel">附近商家</div>
                        </div> */}
                    </div>
                </div>
            </div>

            <div style={{height:"0.5rem"}}/>

            <div className="navBox">
                {/* <div className="navBoxHeader">
                    <Icon icon="ios-apps" />
                    <div className="boxTitle">零担快件</div>
                </div> */}
                <div className="navBoxBody">
                    <div className="navList">
                        <div className="navItem" onClick={()=>{
                            router.go("express");
                        }}>
                            <div className="navIcon">
                                <img src="https://assets.cxt.ant-code.com/images/icon_post_order.svg" />
                            </div>
                            <div className="navLabel">零担快件</div>
                        </div>
                        {/* <div className="navItem" onClick={()=>{
                            router.go("order?title=我的订单");
                        }}>
                            <div className="navIcon">
                                <img src="https://assets.cxt.ant-code.com/images/icon_post_list.svg" />
                            </div>
                            <div className="navLabel">我的订单</div>
                        </div> */}
                        <div className="navItem" onClick={()=>{
                            // router.go("order?title=我的订单");
                            wx.navigateToMiniProgram({
                                appId: 'wx6885acbedba59c14',
                                success(res) {
                                    // 打开成功
                                }
                            })
                        }}>
                            <div className="navIcon">
                                <img src="https://assets.cxt.ant-code.com/images/icon_post_list.svg" />
                            </div>
                            <div className="navLabel">快递查询</div>
                        </div>
                        <div className="navItem" onClick={()=>{
                            router.go("shop");
                        }}>
                            <div className="navIcon">
                                <img src="https://assets.cxt.ant-code.com/images/icon_post_store.svg" />
                            </div>
                            <div className="navLabel">服务站</div>
                        </div>
                        {/* <div className="navItem" onClick={()=>{
                            //    router.go("findorder");
                            router.go("page?id=chinapost");
                            }}>
                            <div className="navIcon">
                                <img src="https://assets.cxt.ant-code.com/images/icon_search.svg" />
                            </div>
                            <div className="navLabel">邮政寄件</div>
                        </div> */}
                        {/* <div className="navItem" onClick={()=>{
                            router.go("store");
                        }}>
                            <div className="navIcon">
                                <img src="https://assets.cxt.ant-code.com/images/icon_store.svg" />
                            </div>
                            <div className="navLabel">商家入驻</div>
                        </div> */}
                    </div>
                </div>
            </div>
            
            <div style={{height:"0.5rem"}}/>

            <div className="navBox">
                <div className="navBoxHeader">
                    <Icon icon="md-basket" />
                    <div className="boxTitle">农村电商</div>
                </div>
                <div className="navBoxBody">
                    <div className="navList">
                        <div className="navItem" onClick={()=>{
                            router.go(`stores?title=${encodeURIComponent('电商平台')}`);
                        }}>
                            <div className="navIcon">
                                <img src="https://assets.cxt.ant-code.com/images/icon_platform.svg" />
                            </div>
                            <div className="navLabel">电商平台</div>
                        </div>
                        <div className="navItem" onClick={()=>{
                            router.go("store");
                        }}>
                            <div className="navIcon">
                                <img src="https://assets.cxt.ant-code.com/images/icon_store.svg" />
                            </div>
                            <div className="navLabel">商家入驻</div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div style={{height:"0.5rem"}}/>
            <TabBar {...{activeType:type}}/>
        </div>
    );
}

export default HomeCct;